import Store from '@nichoth/state';
import inherits from 'inherits';
import mxtend from 'xtend/mutable';
import xtend from 'xtend';
import _ from 'underscore';
import EventsStore from './events';
import RequestState from './request-state';
import Query from './events-query';
import Meta from './metadata';
import PlayerPrefs from './player';
import MiscAssets from './misc-assets';
import Chat from './chat';
import TranscriptStore from './transcript';

import StreamTargets from './stream-targets'
const {
    StreamTargetProviderStore,
    StreamTargetDestinationStore,
    StreamTargetView
} = StreamTargets

var MetamarkersView = Store.extend({
    _state: {
        activeAgendaMarker: {
            itemTitle: '',
            itemText: ''
        },
        edits: null,
        currentTime: 0
    },

    startEditingMarker: function (marker) {
        mxtend(this._state, {
            activeAgendaMarker: marker,
            edits: null,
            currentTime: parseInt(marker.start, 10)
        });
        return this.publish();
    },

    resetEdit: function () {
        mxtend(this._state, {
            edits: null,
            currentTime: 0,
            activeAgendaMarker: {
                itemTitle: '',
                itemText: ''
            }
        });
        return this.publish();
    }
});

function EventsListStore (opts) {
    return {
        analytics: Analytics(),
        eventAnalytics: EventAnalytics(),
        events: EventsStore(),
        encoders: Meta.Encoders(),
        categories: Meta.Categories(),
        keywords: Meta.Keywords(),
        technicians: Meta.Technicians(),
        locations: Meta.Locations(),
        playerPrefs: PlayerPrefs(),

        // streamTargets: Meta.StreamTargetProviders(),
        streamTargets: StreamTargetProviderStore(),
        eventTargetDestinations: StreamTargetDestinationStore(),
        streamTargetView: StreamTargetView(),

        metamarkers: Meta.Metamarkers(),
        metamarkersView: MetamarkersView(),

        miscAssets: MiscAssets(),
        facebookLive: Meta.FacebookLive(),

        chat: Chat(),

        transcript: TranscriptStore(),
        transcriptView: TranscriptView(),

        requests: Store.Merge({
            analytics: RequestState(),
            events: RequestState(),
            encoders: RequestState(),
            categories: RequestState(),
            keywords: RequestState(),
            technicians: RequestState(),
            locations: RequestState(),
            player: RequestState(),
            miscAssets: RequestState(),
            metamarkers: RequestState(),
            facebookLive: RequestState(),
            chat: RequestState(),
            transcript: RequestState(),
            streamTargets: RequestState(),
            eventTargetDestinations: RequestState()
        }),

        query: Query(opts.query),
        socket: Socket(),
        view: View(opts.query),
        messages: Messages()
    };
}

var Messages = Store.extend({
    _state: {
        data: []
    },

    push: function (msg) {
        this._state.data.push(msg);
        return this.publish();
    },

    shift: function () {
        this._state.data.shift();
        return this.publish();
    }
});

var Socket = Store.extend({
    _state: {
        connected: false,
        closed: false,
        error: null,
        trouble: false
    },
    set: function (state) {
        mxtend(this._state, state);
        return this.publish();
    },

    open: function () {
        return this.set({ connected: true, closed: false, trouble: false });
    },

    close: function () {
        return this.set({ connected: false, closed: true, trouble: false });
    },

    error: function (err) {
        return this.set({ connected: false, error: err || true,
            closed: true });
    },

    reconnect: function () {
        return this.set({ trouble: false });
    },

    trouble: function () {
        if (this._state.trouble) return this;
        return this.set({ trouble: true });
    }
});

function View (args) {
    if (!(this instanceof View)) return new View(args);
    Store.call(this, args);
}
inherits(View, Store);

mxtend(View.prototype, {
    _state: function (state) {
        state = state || {};
        let _state = xtend({
            activeEvent: state.eventID || null
        }, state);

        return _state;
    },
    setActiveEvent: function (evID) {
        this._state.activeEvent = this._state.activeEvent == evID ?
            null :
            evID;
        return this.publish();
    }
});


var EventAnalytics = Store.extend({
    _state: {
        data: null
    },

    // [{ eventID, archiveStreams, liveStreams }]
    set: function (list) {
        this._state.data = this._state.data || {};
        mxtend(this._state.data, _.indexBy(list, 'eventID'));
        return this.publish();
    }
});

var TranscriptView = Store.extend({
    _state: {
        editModal: false,
        deleteModal: false,
        createModal: false
    },

    set: function (state) {
        mxtend(this._state, state);
        return this.publish();
    }
});

var Analytics = Store.extend({
    _state: {
        data: null,
        mostWatched: null,
        upcomingEvents: null
    },
    get: function (data) {
        this._state.data = data;
        return this.publish();
    },
    mostWatched: function (data) {
        this._state.mostWatched = data;
        return this.publish();
    },
    upcomingEvents: function (data) {
        this._state.upcomingEvents = data;
        return this.publish();
    }
});

export default EventsListStore;
